import { State } from "../Model/State";
import { reload } from "./ReloadService";
export class RealTimeService {
    constructor(serviceEndpoint, clientId) {
        this.serviceEndpoint = serviceEndpoint;
        this.clientId = clientId;
        this.isEnabled = false;
        this.reconnectAttempts = 0;
        this.maxReconnectAttempts = 5;
        this.pingPongTime = 15 * 1000;
        this.reconnectBaseTime = 5000;
        this.roomId = null;
        this.handlersMap = new Map();
        this.client_id = null;
        this.isOpen = new State(false);
        this.client_id = clientId;
    }
    start(roomId) {
        if (this.isEnabled) {
            return;
        }
        this.isEnabled = true;
        this.roomId = roomId;
        this.connect();
    }
    stop() {
        var _a;
        if (!this.isEnabled) {
            return;
        }
        this.isEnabled = false;
        (_a = this.ws) === null || _a === void 0 ? void 0 : _a.close();
        this.ws = undefined;
    }
    subscribe(eventPattern, handler) {
        if (!this.handlersMap.has(eventPattern)) {
            this.handlersMap.set(eventPattern, this.createEventHandlers(eventPattern));
        }
        this.handlersMap.get(eventPattern).handlers.add(handler);
        this.send('subscribe', eventPattern);
        return () => this.unsubscribe(eventPattern, handler);
    }
    unsubscribe(eventPattern, handler) {
        if (!this.handlersMap.has(eventPattern)) {
            return;
        }
        const { handlers } = this.handlersMap.get(eventPattern);
        handlers.delete(handler);
        if (handlers.size === 0) {
            this.handlersMap.delete(eventPattern);
            this.send('unsubscribe', eventPattern);
        }
    }
    createPatternRegexp(eventPattern) {
        const wildcarded = eventPattern
            .replace(/\*{2}/g, '[\\w\\.-]+')
            .replace(/\*/g, '[\\w-]+');
        return new RegExp(`^${wildcarded}$`);
    }
    send(...args) {
        try {
            if (!this.isOpen.value) {
                return;
            }
            this.ws.send(JSON.stringify(args));
            this.sendPing();
        }
        catch (error) {
            console.log(error);
        }
    }
    connect() {
        if (this.ws) {
            return;
        }
        this.ws = new WebSocket(`${this.serviceEndpoint}?clientId=${this.clientId}&roomId=${this.roomId}`);
        this.ws.addEventListener('open', () => this.onOpen());
        this.ws.addEventListener('close', () => this.onClose());
        this.ws.addEventListener('message', event => this.onMessage(event));
    }
    onOpen() {
        console.log('[Connection] Connection is open');
        reload.set(false);
        this.isOpen.set(true);
        this.reconnectAttempts = 0;
        this.subscribeToAllEvents();
        this.startPingPong();
    }
    async onClose() {
        console.log('[Connection] Connection is close');
        this.isOpen.set(false);
        this.ws = undefined;
        this.stopPingPong();
        this.reconnect();
    }
    onMessage(messageEvent) {
        try {
            if (messageEvent.data === 'pong') {
                console.log('pong made successfully');
                localStorage.setItem('pong', JSON.stringify(new Date()));
                return;
            }
            const event = JSON.parse(messageEvent.data);
            for (const { regexp, handlers } of this.handlersMap.values()) {
                if (regexp.test(event.name)) {
                    handlers.forEach(handler => handler(event));
                }
            }
        }
        catch (error) {
            console.error(error);
        }
    }
    reconnect() {
        window.clearTimeout(this.reconnectTimeout);
        if (!this.isEnabled || this.reconnectAttempts >= this.maxReconnectAttempts) {
            return;
        }
        const reconnectTime = Math.min(this.reconnectBaseTime * Math.pow(2, this.reconnectAttempts), 30000);
        this.reconnectTimeout = window.setTimeout(() => {
            this.reconnectAttempts++;
            this.connect();
        }, reconnectTime);
    }
    subscribeToAllEvents() {
        if (!this.isOpen.value) {
            return;
        }
        for (const eventPattern of this.handlersMap.keys()) {
            this.send('subscribe', eventPattern);
        }
    }
    createEventHandlers(eventPattern) {
        return {
            regexp: this.createPatternRegexp(eventPattern),
            handlers: new Set(),
        };
    }
    startPingPong() {
        if (this.pingPongInterval) {
            return;
        }
        this.pingPongInterval = window.setInterval(() => this.sendPing(), this.pingPongTime);
    }
    stopPingPong() {
        if (!this.pingPongInterval) {
            return;
        }
        window.clearInterval(this.pingPongInterval);
        this.pingPongInterval = undefined;
    }
    sendPing() {
        if (!this.isOpen.value) {
            this.stopPingPong();
            return;
        }
        if (localStorage.getItem('pong')) {
            if (this.checkPingPong()) {
                localStorage.removeItem('pong');
                location.reload();
            }
            else {
                this.ws.send('ping');
                localStorage.setItem('ping', JSON.stringify(new Date()));
            }
        }
        else {
            this.ws.send('ping');
            localStorage.setItem('ping', JSON.stringify(new Date()));
        }
    }
    checkPingPong() {
        const pongDate = new Date(JSON.parse(localStorage.getItem('pong'))).getTime();
        const pingDate = new Date(JSON.parse(localStorage.getItem('ping'))).getTime();
        const today = new Date().getTime();
        return (today - pongDate) > 25 * 1000 || (today - pingDate) > 25 * 1000;
    }
}
